import React, { useState, useEffect } from "react";
import http from "../../../../services/http";
import { ListItemsSkeleton } from "../../../../components/page-skeleton";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import "./styles.scss";

function OauthCallback() {
  // STATES
  const [isLoading, setLoading] = useState(true);

  // CONST VALS
  const history = useHistory();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const code = searchParams.get("code");
  const code_verifier = sessionStorage.getItem("salesforce_code_verifier");
  const redirectTo = sessionStorage.getItem("oauth-redirect");

  // HANDLERS
  const redirectHandler = (fromSuccess) => {
    const url = redirectTo || "/dataset"
    history.push(fromSuccess ? `${url}?connected=true` : url);
    sessionStorage.removeItem("salesforce_code_verifier");
    sessionStorage.removeItem("oauth-redirect");
  };

  // HELPERS
  const exchangeTokenHelper = async () => {
    setLoading(true);
    await http
      .post("connect-crm", {
        code,
        code_verifier,
      })
      .then((res) => redirectHandler(true))
      .catch((err) => {
        redirectHandler(true);
        toast.error(err.response?.data?.error || "Something went wrong");
      });
  };

  // HOOKS
  useEffect(() => {
    if (code && code_verifier) {
      exchangeTokenHelper();
    } else {
      toast.error("Invalid request");
      history.push(redirectTo || "/dataset");
    }
  }, [code, code_verifier]);

  return (
    <div className="oauth-callback">
      {isLoading && (
        <div className="loader-wrapper">
          <h2>Connecting to CRM</h2>
          <ListItemsSkeleton rows={3} />
        </div>
      )}
    </div>
  );
}

export default OauthCallback;
